import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Wallet } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/** Blocks POS terminals until on-chain settlement wallet is configured. */
export function SettlementGuard({ children }: { children: ReactNode }) {
  const { merchant } = useAuth();
  const configured = merchant?.settlement_wallet_configured === true;

  if (configured) return <>{children}</>;

  return (
    <div className="max-w-xl mx-auto text-center py-16">
      <div className="inline-flex p-4 rounded-2xl mb-6 bg-onyx-gold/10 text-onyx-gold">
        <Wallet size={40} />
      </div>
      <h2 className="font-display text-3xl mb-3">Settlement wallet required</h2>
      <p className="text-onyx-muted leading-relaxed">
        Configure your Solana payout wallet before pairing POS terminals. Customer payments are split on-chain
        (98.5% to you) via the Onyx Pay program.
      </p>
      <Link to="/settlement" className="inline-block mt-8 text-sm font-semibold underline text-onyx-gold">
        Set up settlement wallet →
      </Link>
    </div>
  );
}
